import { Feature } from "geojson";
import wkx from "wkx";
import * as L from "leaflet";
import { feature as turfFeature, MultiPolygon, Polygon } from "@turf/helpers";

export function featureToWKT(data: Feature): string {
  const wktGeometry = wkx.Geometry.parseGeoJSON(data.geometry);
  return wktGeometry.toWkt();
}

export function latlngToWkt(latlng: L.LatLngLiteral): string {
  const { lat, lng } = latlng;
  return new wkx.Point(lng, lat).toWkt();
}

export function wktPointToLatlng(wkt: string): L.LatLngLiteral {
  const point = wkx.Geometry.parse(wkt) as wkx.Point;
  return { lat: point.y, lng: point.x };
}

export function wktPolygonToFeature(wkt: string): Feature {
  const geometry = wkx.Geometry.parse(wkt).toGeoJSON();
  // const feature = turfFeature(geometry) as Feature<Polygon | MultiPolygon>;
  const feature = turfFeature(geometry) as Feature<Polygon | MultiPolygon>;
  return feature;
}
